import { ModalProps } from 'antd/lib'

import { type Question } from '@/types'
import Modal from '@/ui/Modal'
import cn from '@/utils/tailwind/cn'

import { CalculationFunction } from '../CalculationFunction'

type Props = {
  questions: Question[]
  isOpen: boolean
  onClose: () => void
  initialValues?: string
  onSave: (formula: string) => void
} & ModalProps

export const CalculationFunctionModal = ({
  questions,
  isOpen,
  onClose,
  onSave,
  initialValues,
  className,
  ...props
}: Props) => {
  let title = 'Add Function'
  if (initialValues) title = 'Edit Function'

  return (
    <Modal
      {...props}
      className={cn('[&_.ant-modal-footer]:hidden', className)}
      footer={() => undefined}
      onCancel={onClose}
      open={isOpen}
      title={title}
    >
      {isOpen ? (
        <CalculationFunction
          {...{ questions, onClose, initialValues, onSave }}
          key={initialValues}
        />
      ) : null}
    </Modal>
  )
}
